import $ from 'jquery'

function smartSearch($element) {
  /* PRIVATE VARIABLES */

  var $mainContainer = $element,
      $smartSearchInput,
      $smartSearchForm;

  /* PRIVATE METHODS */

  // constructor
  function init() {
    $smartSearchInput        = $('.flexible-header__searchfield', $mainContainer);
    $smartSearchForm         = $('#flexible-header__search-form');

    bindDomElements();
  }

  function bindDomElements() {
    // Submit
    $('.search-icon, .w-search-bar-icon', $mainContainer).on('click', submitSearch);

    // Keyups
    $smartSearchInput.on('keyup', keyUpHandler);
  }

  function keyUpHandler(e) {
    switch (e.keyCode) {
      case $.ui.keyCode.ENTER:
        submitSearch();
        break;
      case $.ui.keyCode.UP:
        break;
      case $.ui.keyCode.DOWN:
        break;
      case $.ui.keyCode.TAB:
        break;
    }
  }

  function submitSearch() {
    $smartSearchForm.trigger('submit');
  }

  // run constructor
  init();

  /* PUBLIC METHODS */

  return {
    // public methods go here
  };
}

// jQuery plugin method
$.fn.smartSearch = function() {
  return this.each(function() {
    var $this = $(this);

    // Store plugin object in this element's data if it doesn't already exist
    if (!$this.data('smartSearch')) {
      $this.data('smartSearch', smartSearch($this));
    }
  });
};
